import { BrowserRouter as Router, Route, Routes, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const FAQ = () => {

  return (
    <div className="faq_wrapper">
		<div className="otherpage_banner" style={{ backgroundImage: `url(${homeUrl}/assets/img/faq-bgimg.jpg)`,}}>
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="toptitlebox">
							<div className="breadcrumb_mainsec">
								<ul>
									<li><a href="#">Home</a></li>
									<li><span>Frequently Asked Questions</span></li>
								</ul>
							</div>
							
							<div className="titlesec">
								<h2>Frequently Asked Questions</h2>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			
		<div className="faq_mainsec">
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
						<div className="contntbox">
							<p>Below are common questions and answers to help users better understand CoinViews and our policies:</p>
							
							<div className="faq_boxsec">
								<div className="accordion" id="accordionExample">
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingOne">
											<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
												What is CoinViews?
											</button>
										</h2>
										
										<div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
											<div className="accordion-body">
												<p>CoinViews is an informational platform that aggregates cryptocurrency price data, news, Market Analysis, Trading Guide and Trading Signals. We do not buy or sell cryptocurrencies on your behalf.</p>
											</div>
										</div>
									</div>
									
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingTwo">
											<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
												Does CoinViews provide investment advice?
											</button>
										</h2>
										
										<div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
											<div className="accordion-body">
												<p>No. CoinViews provides market data and educational content but does not offer personalized investment advice or financial services. Before making investment decisions, consult a licensed adviser.</p>
											</div>
										</div>
									</div>
									
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingThree">
											<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
												Where does CoinViews get its data?
											</button>
										</h2>
										
										<div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
											<div className="accordion-body">
												<p>We obtain price and market data from third‑party providers such as CoinGecko and other reputable APIs. Data may occasionally be delayed or inaccurate due to provider issues; always verify prices independently.</p>
											</div>
										</div>
									</div>
									
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingFour">
											<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
												How often is the data updated?
											</button>
										</h2>
										
										<div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
											<div className="accordion-body">
												<p>Prices are refreshed at regular intervals (e.g., every few minutes). News and airdrop listings are updated as new information becomes available.</p>
											</div>
										</div>
									</div>
									
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingFive">
											<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
												Do you have an affiliate program?
											</button>
										</h2>
										
										<div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
											<div className="accordion-body">
												<p>CoinViews may include affiliate links to exchanges, wallets or projects. When you click on these links and perform eligible actions, we may earn a commission. Affiliate relationships do not influence our editorial content. We will disclose affiliate links on pages where they appear.</p>
											</div>
										</div>
									</div>
									
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingSix">
											<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
												How do you protect my privacy?
											</button>
										</h2>
										
										<div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
											<div className="accordion-body">
												<p>We collect minimal personal data and use technical and organizational measures to safeguard it (see our Privacy Policy). We do not sell personal data to third parties and we comply with applicable data‑protection laws.</p>
											</div>
										</div>
									</div>
									
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingSeven">
											<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
												Is CoinViews compliant with regulations?
											</button>
										</h2>
										
										<div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#accordionExample">
											<div className="accordion-body">
												<p>We strive to comply with relevant laws and industry standards. Because crypto regulation varies by jurisdiction, users are responsible for ensuring that their activities comply with local rules.</p>
											</div>
										</div>
									</div>
									
									<div className="accordion-item">
										<h2 className="accordion-header" id="headingEight">
											<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
												Who can I contact if I have questions?
											</button>
										</h2>
										
										<div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#accordionExample">
											<div className="accordion-body">
												<p>For general inquiries, For legal matters. For privacy matters, contact <strong><a href="mailto:hello@coinviews.com">hello@coinviews.com.</a></strong></p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
  );
};

export default FAQ;